module.exports = __webpack_public_path__ + "assets/img/success.443eb1c5.png";